module.exports = __webpack_public_path__ + "img/5@3x.c1403b26.png";